import styled from 'styled-components'

export const TermsAndConditions = styled.div`
  max-width: 50em;
  margin-left: auto;
  margin-right: auto;
  text-align: justify;
`

export const LowerRomanNumeralsList = styled.ol`
  list-style-type: lower-roman;
`
